import { render, staticRenderFns } from "./periods_list.vue?vue&type=template&id=07b3f097&"
import script from "./periods_list.vue?vue&type=script&lang=js&"
export * from "./periods_list.vue?vue&type=script&lang=js&"
import style0 from "./periods_list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fperiods%2Fperiods_list.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/table.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fperiods%2Fperiods_list.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "@/lang/search.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fperiods%2Fperiods_list.vue"
if (typeof block2 === 'function') block2(component)

export default component.exports